import axios from "axios";

const get_access_token = async (share_token) => {
  try {
    var data = {
      share_token: share_token,
    };
    const res = await axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/sign_in_mini_app`, data);
    if (res.data.result === "success") {
      return res.data.data;
    } else {
      return null;
    }
  } catch (err) {
    console.error("err ~ services get_access_token:", err);
    return null;
  }
};

export default get_access_token;
